export default __webpack_public_path__ + "static/media/ubuntu.f9fb429d.png";